import React from "react";
import { auth } from "./firebaseConfig";

function Dashboard() {
  const user = auth.currentUser;

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#e8f0e6",
        color: "#3b3b3b",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "40px 20px",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "12px",
          padding: "30px 40px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          maxWidth: "600px",
          textAlign: "center",
        }}
      >
        <h1 style={{ color: "#5a6b55", marginBottom: "15px" }}>
          Welcome to CreatorFlow 🌿
        </h1>
        <p style={{ fontSize: "16px", marginBottom: "10px" }}>
          Hello, <strong>{user?.email || "Guest"}</strong> 👋
        </p>
        <p style={{ fontSize: "15px", lineHeight: "1.6", color: "#555" }}>
  <strong>CreatorFlow</strong> is your personal content hub — built to help you
  plan, organize, and grow your creative projects. Whether you're a content
  creator, social media manager, or creative thinker, this dashboard keeps all
  your ideas, reminders, and content plans in one place.
</p>

<p style={{ fontSize: "15px", lineHeight: "1.6", color: "#555" }}>
  Use it to jot down fresh content ideas, schedule your posts with reminders,
  and view everything clearly on your weekly calendar. Stay consistent,
  stay inspired, and make your creative flow effortless.
</p>

        <p
          style={{
            fontSize: "14px",
            marginTop: "20px",
            color: "#6b7a6b",
            fontStyle: "italic",
          }}
        >
          🌱 Tip: Use the navigation bar above to jump between your ideas,
          reminders, and calendar. Stay organized, stay inspired!
        </p>
      </div>
    </div>
  );
}

export default Dashboard;
